import { SeriesInfo } from './HorizontalCricketWidget'
import { distinct } from 'common/helpers/utils'

/**
 * Sorts incoming seriesInfo to an array of seriesIds based on logic
 *  if live series in play then return recently passed / upcoming series, otherwise
 *  return live, past, and upcoming
 *
 * @param series seriesInfo containing the id, startDate, endDate
 * @param mockCurrentDate for testing purposes only
 * @param pastFutureCount count used to return past/upcoming series, its up to but not guaranteed
 */
export function sortSeries(
    series: Array<SeriesInfo>,
    pastCount: number,
    upcomingCount: number,
    mockCurrentDate = new Date()
): number[] {
    // Convert dates
    const datesConverted = series.map(s => ({
        id: s.id,
        startDateTime: new Date(s.startDate),
        endDateTime: new Date(s.endDate),
    }))

    // Sort by start date ascending
    const sortedByStart = datesConverted
        .slice()
        .sort((a, b) => a.startDateTime.getTime() - b.startDateTime.getTime())

    // Sort by end date descending
    const sortedByEndDesc = datesConverted
        .slice()
        .sort((a, b) => b.endDateTime.getTime() - a.endDateTime.getTime())

    // return currently running series
    const currentSeries = sortedByStart.filter(
        a => a.startDateTime <= mockCurrentDate && a.endDateTime >= mockCurrentDate
    )

    // upcoming current series
    const currentSeriesUpcoming = sortedByStart.filter(
        a => a.startDateTime > mockCurrentDate && a.endDateTime > mockCurrentDate
    )

    // recently passed current series
    const currentSeriesPast = sortedByEndDesc.filter(
        a => a.startDateTime < mockCurrentDate && a.endDateTime < mockCurrentDate
    )

    // returns up to two most recent series followed by up to two upcoming series
    const recentlyPassedAndUpcoming = distinct([
        ...currentSeriesPast.slice(0, pastCount).map(s => s.id),
        ...currentSeriesUpcoming.slice(0, upcomingCount).map(s => s.id),
    ])

    // if no currently running series return recently passed series and upcoming series, otherwise
    // return live, past, and upcoming
    return currentSeries.length > 0
        ? distinct([...currentSeries.map(s => s.id), ...recentlyPassedAndUpcoming])
        : recentlyPassedAndUpcoming
}
